// extracted by mini-css-extract-plugin
export var container = "section-simulation-module--container--9JQnA";
export var contents = "section-simulation-module--contents--5XVPK";
export var phrase = "section-simulation-module--phrase--PXYul";
export var title = "section-simulation-module--title--HF6nw";
export var description = "section-simulation-module--description--ieCv+";
export var buttons = "section-simulation-module--buttons--QVy9p";
export var background = "section-simulation-module--background--EqBtd";